const React = require('react');
const T = require('prop-types');
const OfflineIndicator = require('components/OfflineIndicator');
const FocusIndicator = require('components/FocusIndicator');
const { default: Classes } = require('./styles.scss');
const { ELEMENT_IDS } = require('utils/constants');

const internals = {};

module.exports = class ScrollContainerLayout extends React.PureComponent {

    static propTypes = {
        children: T.node,
        isOffline: T.bool
    }

    componentDidMount() {
        internals.lockWindowScroll();
    }

    componentWillUnmount() {
        internals.unlockWindowScroll();
    }

    render() {

        const { styles } = internals;

        const { ...rest } = this.props;

        return <div className={Classes.wrapper} {...rest}>
            <OfflineIndicator isOffline={!!this.props.isOffline} />
            <div className={Classes.main}>

                {/* Portal for scroll sibling top */}
                <div
                    id={ELEMENT_IDS.scrollPortalIds.top}
                    className={Classes.scrollPortalTop}
                />
                {/* Scroll container */}
                <div
                    id={ELEMENT_IDS.scrollContainer}
                    className={Classes.scrollContainer}
                    onFocus={FocusIndicator.onFocusHandler}
                    onBlur={FocusIndicator.onBlurHandler}
                >
                    {/* Portal for scroll padding top */}
                    <div
                        id={ELEMENT_IDS.scrollPortalPaddingIds.top}
                        style={styles.scrollPadding}
                    />

                    <div className={Classes.mainInnerWrapper}>
                        {/* Main content */}
                        {this.props.children}
                    </div>

                    {/* Portal for scroll padding bottom */}
                    <div
                        id={ELEMENT_IDS.scrollPortalPaddingIds.bottom}
                        style={styles.scrollPadding}
                    />
                </div>

                {/* Portal for scroll sibling bottom */}
                <div
                    id={ELEMENT_IDS.scrollPortalIds.bottom}
                    className={Classes.scrollPortalBottom}
                />
                <FocusIndicator />
            </div>
        </div>;
    }
};

internals.styles = {
    scrollPadding: {
        width: '100%'
    }
};

internals.windowScrollLockState = null;

internals.lockWindowScroll = () => {
    if (typeof document === 'undefined') {
        return;
    }

    const docEl = document.documentElement;
    const body = document.body;

    if (!docEl || !body) {
        return;
    }

    if (!internals.windowScrollLockState) {
        internals.windowScrollLockState = {
            docOverflow: docEl.style.overflow,
            docOverscrollBehavior: docEl.style.overscrollBehavior,
            bodyOverflow: body.style.overflow,
            bodyOverscrollBehavior: body.style.overscrollBehavior
        };
    }

    docEl.style.overflow = 'hidden';
    docEl.style.overscrollBehavior = 'none';
    body.style.overflow = 'hidden';
    body.style.overscrollBehavior = 'none';
};

internals.unlockWindowScroll = () => {
    if (typeof document === 'undefined') {
        return;
    }

    const state = internals.windowScrollLockState;

    if (!state) {
        return;
    }

    const docEl = document.documentElement;
    const body = document.body;

    if (!docEl || !body) {
        return;
    }

    docEl.style.overflow = state.docOverflow || '';
    docEl.style.overscrollBehavior = state.docOverscrollBehavior || '';
    body.style.overflow = state.bodyOverflow || '';
    body.style.overscrollBehavior = state.bodyOverscrollBehavior || '';

    internals.windowScrollLockState = null;
};
